<template>
	<div id="app">
          <!--左上下布局    -->
		<Layout class="app-frame" :siderCollapsed="sliderCollapsed" :siderFixed="layoutConfig.siderFixed">
          <!--左侧区域：目录和logo区域       -->
			<Sider :theme="layoutConfig.siderTheme">
				<appMenu :theme="layoutConfig.siderTheme"></appMenu>
			</Sider>
            <!--右侧区域：头部和内容区域       -->
			<Layout :headerFixed="layoutConfig.headerFixed">
              <!--头部区域      -->
				<HHeader theme="white">
					<appHead @openSetting="openSetting=true" :layoutConfig="layoutConfig"></appHead>
				</HHeader>
              <!--tabs区域 -->
				<SysTabs v-if="layoutConfig.showSystab" homePage="Home"></SysTabs>
              <!--内容区域      -->
				<Content>
					<div class="app-frame-content ">
              <!-- router-view 路由表单展示区           -->
						<router-view v-if="isRouterAlive"></router-view>
					</div>
                <!--内容： 底部区域      -->
					<HFooter>
						<appFooter></appFooter>
					</HFooter>
				</Content>
			</Layout>
		</Layout>
	</div>
</template>
<script>

	import appHead from './app/app-header';
	import appMenu from './app/app-menu';
	import appFooter from './app/app-footer';
	import {mapState} from 'vuex';
	import SysTabs from './app/sys-tabs/sys-tabs';

  /**
   * 主应用界面
   */
	export default {
		name: "FXY",
			/**
		 * 提供一个可在子组件中注入使用的方法。
		 * Vue 的 provide/inject 特性允许祖先组件向其所有子孙后代组件注入依赖，
		 * 而不需要在每一级组件中逐层传递 props。
		 * 这里提供了一个名为 reload 的方法，子组件可以通过 inject 来使用该方法。
		 * @returns {Object} 一个对象，包含可注入的属性和方法。
		 */
		provide() {
			return {
				// 提供 reload 方法，子组件可通过 inject 获取并调用此方法
				reload: this.reload
			}
		},

		data() {
			return {
								// 控制设置面板是否打开的状态，初始值为 false 表示设置面板默认关闭
				openSetting: false,
				// 控制路由视图是否存活的状态，初始值为 true 表示路由视图默认处于激活状态
				isRouterAlive: true,
				// 布局配置对象，包含侧边栏、头部、系统标签页等布局相关的配置信息
				layoutConfig: {
					// 侧边栏主题样式，'dark' 表示深色主题
					siderTheme: 'dark',
					// 控制是否显示系统标签页，初始值为 false 表示默认不显示
					showSystab: false,
					// 控制头部是否固定，初始值为 true 表示头部默认固定显示
					headerFixed: true,
					// 控制侧边栏是否固定，初始值为 true 表示侧边栏默认固定显示
					siderFixed: true
				}

			};
		},
		methods: {
						/**
			 * 更新布局配置
			 * 该方法用于动态更新布局配置对象中的指定属性值。
			 * @param {Object} param - 参数对象
			 * @param {string} param.key - 布局配置对象中需要更新的属性名
			 * @param {any} param.value - 布局配置对象中对应属性的新值
			 */
			updateLayoutConfig({key, value}) {
				// 根据传入的 key 更新布局配置对象中对应属性的值
				this.layoutConfig[key] = value;
			},
			/**
			 * 重新加载路由视图
			 * 该方法通过控制路由视图的存活状态，实现路由视图的重新加载。
			 * 先将路由视图置为不存活状态，再在下一个 DOM 更新周期将其置为存活状态。
			 */
			reload() {
				// 将路由视图置为不存活状态
				this.isRouterAlive = false;
				// 在下一个 DOM 更新周期后执行回调函数
				this.$nextTick(() => {
					// 将路由视图重新置为存活状态，实现重新加载
					this.isRouterAlive = true;
				});
			}

		},
			/**
		 * 计算属性，用于从 Vuex 状态管理中获取数据。
		 * 计算属性会基于它们的响应式依赖进行缓存，只有当依赖发生变化时才会重新计算。
		 */
		computed: {
			/**
			 * 使用 Vuex 的 mapState 辅助函数将 Vuex store 中的 `sliderCollapsed` 状态映射到当前组件的计算属性中。
			 * 这样在组件中可以直接通过 `this.sliderCollapsed` 访问 Vuex store 里的 `sliderCollapsed` 状态。
			 * 当 Vuex store 中的 `sliderCollapsed` 状态发生变化时，该计算属性会自动更新。
			 */
			...mapState(['sliderCollapsed'])
		},

		components: {
			appHead,
			appMenu,
			appFooter,
			SysTabs
		}
	};
</script>
